import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";

const TenantKYCModal = ({
  onClose,
  settingsData,
  tenantKYCMutate,
  tenantKYCLoading,
}) => {
  const [settings, setSettings] = useState({
    onboardingPaymentReminder: settingsData?.onboardingPaymentReminder === 1,
    tenantWelcomeMessage: settingsData?.tenantWelcomeMessage === 1,
    tenantProfileLock: settingsData?.tenantProfileLock === 1,
    enableKYC: settingsData?.enableKYC === 1,
    kycMandatory: settingsData?.kycMandatory === 1,
  });

  const toggleSetting = (key) => {
    const updatedState = { ...settings, [key]: !settings[key] };
    setSettings(updatedState);

    tenantKYCMutate(updatedState);
  };

  return (
    <div className="bg-white w-full h-full flex flex-col">
      <div className="flex items-center justify-between bg-[#0078BD] py-6 px-4">
        <Title className="text-white">Tenant Onboarding & KYC Settings</Title>
        <button onClick={onClose}>
          <MdClose color="white" size={24} />
        </button>
      </div>

      <div className="px-4 h-full flex flex-col justify-between pb-4 relative">
        <Wrapper>
          <Section>
            <SectionTitle>Onboarding Settings</SectionTitle>
            <ToggleRow>
              <div>
                <Label>Onboarding Payment Reminders</Label>
                <Description>
                  When enabled, all payment and receipts <br />
                  communication will be started.
                </Description>
              </div>
              <Toggle
                checked={settings.onboardingPaymentReminder}
                onChange={() => toggleSetting("onboardingPaymentReminder")}
              />
            </ToggleRow>
            <ToggleRow>
              <div>
                <Label>Tenant Welcome Message</Label>
                <Description>
                  When enabled, an onboarding welcome message <br />
                  will be shared with new tenants.
                </Description>
              </div>
              <Toggle
                checked={settings.tenantWelcomeMessage}
                onChange={() => toggleSetting("tenantWelcomeMessage")}
              />
            </ToggleRow>
            <Row>
              <div>
                <Label>Tenant Profile Lock</Label>
                <Description>
                  When enabled, the tenant's profile will be locked
                  <br />
                  automatically and cannot be edited by tenants.
                </Description>
              </div>
              <Toggle
                checked={settings.tenantProfileLock}
                onChange={() => toggleSetting("tenantProfileLock")}
              />
            </Row>
          </Section>

          <Section>
            <SectionTitle>KYC Settings</SectionTitle>
            <ToggleRow>
              <div>
                <Label>Enable KYC</Label>
                <Description>
                  When enabled, all payment and receipts
                  <br />
                  communication will be started.
                </Description>
              </div>
              <Toggle
                checked={settings.enableKYC}
                onChange={() => toggleSetting("enableKYC")}
              />
            </ToggleRow>
            <Row>
              <div>
                <Label>KYC is Mandatory</Label>
                <Description>
                  When enabled, onboarding welcome messages
                  <br /> will be shared with new tenants.
                </Description>
              </div>
              <Toggle
                checked={settings.kycMandatory}
                onChange={() => toggleSetting("kycMandatory")}
              />
            </Row>
          </Section>
        </Wrapper>

        {/* <BtnWrapper>
          <SecondaryButton>Copy settings to other properties</SecondaryButton>
          <PrimaryButton>Edit</PrimaryButton>
        </BtnWrapper> */}
      </div>
    </div>
  );
};

const Wrapper = tw.div`grid gap-6 my-6`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const Section = tw.div``;
const SectionTitle = tw.h2`text-lg font-semibold text-gray-900`;
const ToggleRow = tw.div`flex justify-between py-2 border-b border-gray-200 items-center`;
const Row = tw.div`flex justify-between py-2 items-center`;
const Label = tw.span`text-gray-900`;
const Description = tw.p`text-gray-400 text-sm md:mx-1`;
const BtnWrapper = tw.div`flex gap-3`;
const PrimaryButton = tw.button`bg-[#0078BD] w-2/5 text-white px-4 py-2 rounded-lg hover:bg-[#65adf0]`;
const SecondaryButton = tw.button`bg-white w-3/5 border border-[#0078BD] text-[#0078BD] font-medium px-4 py-1 rounded-lg`;

const Toggle = ({ checked, onChange }) => (
  <label className="relative inline-flex items-center cursor-pointer">
    <input
      type="checkbox"
      className="sr-only peer"
      checked={checked}
      onChange={onChange}
    />
    <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
  </label>
);

export default TenantKYCModal;
